import TweetEmbed from "react-tweet-embed";
import { SanityTweet } from "lib/sanity/types";

export const Tweet: React.FC<{
  item: SanityTweet;
}> = (props) => {
  return <TweetEmbed id={props.item.id} />;
};
